import * as wjcCore from "@grapecity/wijmo"
import dayjs from "dayjs"
import React, { useCallback, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useSelector } from "react-redux"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { RootState } from "../../../globalStore/rootreducer"
import { TLoginUserInfo } from "../../../service/auth/TAuth"
import DashboardService from "../../../service/dashboard/dashboardService"
import {
  T部所別車輌台数,
  T配車件数,
} from "../../../service/dashboard/TDashboard"
import BusyoService from "../../../service/master/busyo/busyoService"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import TopCategoryOuter from "../TopCategoryOuter"
import { HaisyaKensuGrid } from "./HaisyaKensuGrid"
import { TukekaeZyusinKensuGrid } from "./TukekaeZyusinKensuGrid"

export type T付替受信件数 = {
  [受注部所名: string]: number
}

/**
 * 配車件数
 */
const HaisyaKensu = React.memo(() => {
  //#region [state]
  const [searchStart, setSearchStart] = useState(false)
  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  const loginUserInfo = useSelector(
    (state: RootState) => state.user.LoginUserInfo
  )

  const [年月, set年月] = useState<string>()
  const [配車件数, set配車件数] = useState<T配車件数[]>()
  const [車輌台数, set車輌台数] = useState<T部所別車輌台数[]>()
  const [営業日数, set営業日数] = useState<number>(dayjs().daysInMonth())

  // 部所
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const searchFunction = useCallback(async (condition: TLoginUserInfo) => {
    // 運行部所でも全部所確認を行う（付替えをするため）ため、全部所分を取得
    const 配車件数Res = await new DashboardService().getHaisyaKensu({})
    const 車輌台数Res = await new DashboardService().getBusyoBetuSyaryoCount()
    const 営業日数Res = await new DashboardService().getBusinessDay()

    set配車件数(配車件数Res?.data)
    set車輌台数(車輌台数Res?.data)
    // 営業日数取れなければ月間日数を埋める
    set営業日数(営業日数Res?.data ?? dayjs().daysInMonth())
    set年月(
      配車件数Res?.data[0] ? dayjs().format("YYYY年MM月DD日 HH:mm:ss") : ""
    )
    setSearchStart(false)
  }, [])

  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setComboBoxDataInitialized(true)
    })
  }, [])

  useEffect(() => {
    if (!comboBoxDataInitialized || !部所ComboBox) return
    if (loginUserInfo.運行部所フラグ === 1) {
      set部所コード(loginUserInfo.部所コード)
    }
    setSearchStart(true)
  }, [comboBoxDataInitialized, loginUserInfo, 部所ComboBox])

  //#endregion

  return (
    <div className="w-100 h-100">
      <div className="w-100">
        <div className={"w-13rem text-end d-inline-block"}>
          <ComboBox.Busyo
            placeholder="部所"
            isDisabled={searchStart}
            isLoadEnded={部所isLoadEnded}
            setIsLoadEnded={set部所isLoadEnded}
            isAllSelect={true}
            isRequired={true}
            itemsSource={部所ItemSource}
            selectedValue={部所コード}
            listFilter={(d) => d.運行部所フラグ === 1}
            setSelectedValue={(v) => {
              set部所コード(v)
            }}
            ComboBox={部所ComboBox}
            setComboBox={set部所ComboBox}></ComboBox.Busyo>
        </div>
        <div className="d-inline-block">
          <Button
            className="ms-2"
            variant="caution"
            disabled={searchStart}
            onClick={() => {
              setSearchStart(true)
            }}>
            最新件数取得
          </Button>
        </div>
      </div>
      <TopCategoryOuter
        searchFunction={searchFunction}
        searchStartFlag={searchStart}>
        <div className="w-100">
          <table className="w-100">
            <tbody>
              <tr>
                <td>
                  <h4 className="topLabel2">今月の付替 受信件数</h4>
                </td>
                <td>
                  <h4 className="topLabel2">配車件数</h4>
                </td>
              </tr>
              <tr style={{ maxHeight: "60%" }}>
                <td className="h-80 w-50 align-top">
                  <TukekaeZyusinKensuGrid
                    haisyaKensu={配車件数}
                    busyoCode={部所コード}></TukekaeZyusinKensuGrid>
                </td>
                <td className="h-80 w-50 align-top">
                  <HaisyaKensuGrid
                    haisyaKensu={配車件数}
                    syaryoCount={車輌台数}
                    businessDay={営業日数}
                    busyoCode={部所コード}></HaisyaKensuGrid>
                </td>
              </tr>
              {!wjcCore.isNullOrWhiteSpace(年月 ?? "") && (
                <tr>
                  <td className="text-end" colSpan={2}>
                    {`${年月}時点`}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </TopCategoryOuter>
    </div>
  )
})

export default HaisyaKensu
